import { Button } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ImagePicker } from "../../../Shared/useImageCrop/ImagePicker";

export default function AddEvent() {
  const [title, setTitle] = useState("");
  const [metaKeyword, setMetaKeyword] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [content, setContent] = useState("");
  const [location, setLocation] = useState("");
  const [image, setImage] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const navigate = useNavigate();

  const handleEditorChange = (value) => setContent(value);

  const addEvent = async (e) => {
    e.preventDefault();

    if (!title || !content || !startDate || !endDate) {
      toast.error("Please fill in all required fields");
      return;
    }

    const reqBody = new FormData();
    reqBody.append("store", localStorage.getItem("store_id"));
    reqBody.append("Title", title);
    reqBody.append("meta_keyword", metaKeyword);
    reqBody.append("meta_description", metaDescription);
    reqBody.append("Content", content);
    image && reqBody.append("images", image);
    reqBody.append("location", location);
    reqBody.append("start_date", startDate);
    reqBody.append("end_date", endDate);

    try {
      const response = await axios.post(
        "https://m1blog.aaragroups.com/blog/api/admin/api/event_list_api/",
        reqBody,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token: localStorage.getItem("token"),
          },
        },
      );

      if (response?.data?.response_code === 200) {
        toast.success(response.data.message);
        navigate("/event");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error adding event:", error);
      toast.error("Failed to add event");
    }
  };

  return (
    <div className="flex flex-col w-full">
      <div className="px-5 mt-5 bg-white shadow-lg rounded-md">
        <p className="my-5 text-xl font-bold text-center border-b-2 border-black">
          Add Event
        </p>
        <form onSubmit={addEvent}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {/* Title */}
            <div>
              <p className="p-1 text-sm font-semibold">Title</p>
              <input
                type="text"
                value={title}
                placeholder="Event Title"
                className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            {/* Meta Description */}
            <div>
              <p className="p-1 text-sm font-semibold">Meta Description</p>
              <input
                type="text"
                value={metaDescription}
                placeholder="Meta Description"
                className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                onChange={(e) => setMetaDescription(e.target.value)}
              />
            </div>

            {/* Meta Keyword */}
            <div>
              <p className="p-1 text-sm font-semibold">Meta Keyword</p>
              <input
                type="text"
                value={metaKeyword}
                placeholder="Meta Keyword"
                className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                onChange={(e) => setMetaKeyword(e.target.value)}
              />
            </div>

            {/* Start Date */}
            <div>
              <p className="p-1 text-sm font-semibold">Event Start Date</p>
              <input
                type="date"
                value={startDate}
                className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>

            {/* End Date */}
            <div>
              <p className="p-1 text-sm font-semibold">Event End Date</p>
              <input
                type="date"
                value={endDate}
                className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>

            {/* Location */}
            <div>
              <p className="p-1 text-sm font-semibold">Location</p>
              <input
                type="text"
                value={location}
                placeholder="Event Location"
                className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                onChange={(e) => setLocation(e.target.value)}
              />
            </div>

            {/* Image */}
            <div>
              <p className="p-1 text-sm font-semibold">Event Image</p>
              <ImagePicker placeholder="Input Image" handleChange={setImage} />
            </div>
          </div>

          {/* Content */}
          <div className="mt-4">
            <p className="p-1 text-sm font-semibold">Content</p>
            <ReactQuill
              value={content}
              onChange={handleEditorChange}
              className="w-full h-48 text-lg bg-gray-100 border border-gray-300 rounded"
            />
          </div>

          {/* Submit Button */}
          <div className="flex items-center justify-center w-full mt-5 mb-5">
            <Button
              className="!w-32 !bg-green-500"
              type="submit"
              variant="contained"
            >
              Add Event
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
